import styled from 'src/styles/theme';
import { rem } from 'polished';
import { ModalPostalCodeTemplate } from './ModalPostalCodeTemplate';

export const ModalPostalCodeStyled = styled(ModalPostalCodeTemplate)`
    width: 100%;

    .title {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.black};
        margin-top: -${rem(45)};
        width: 95%;
    }

    .description {
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        color: ${({ theme }) => theme.colors.black};
        padding: ${rem(15)} 0;
    }

    .input {
        display: flex;
        min-height: ${rem(45)};
        margin-bottom: ${rem(20)};

        > div {
            width: 60%;
            margin-right: ${rem(10)};
        }

        &.hasError {
            input {
                border-color: ${({ theme }) => theme.colors.danger} !important;
            }
        }

        button {
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.white};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            padding-left: ${rem(20)};
            padding-right: ${rem(20)};
            border: none;
            cursor: pointer;
            height: ${rem(48)};
        }
    }

    .error {
        color: ${({ theme }) => theme.colors.danger};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        margin-top: -${rem(10)};
        position: absolute;
    }

    .noSelect {
        color: ${({ theme }) => theme.colors.danger};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        padding-bottom: ${rem(5)};
    }

    .geolocation-title {
        display: none;
    }
`;
